

export default {
  name: 'WebpToJpg',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "Why are photos saved as WebP?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "WebP allows images to be displayed in high quality quickly on the internet. It is smaller than other formats and offers many storage options to users, including lossless compression."
          }
      },{
          "@type": "Question",
          "name": "How do I turn off WebP format?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "If you want to turn off WebP images, I recommend installing a conversion plugin. These plugins will help you convert WebP files to another popular format like JPG or PNG before you save them. On the other hand, you can consider some tips and tricks I have shared above."
          }
      },{
          "@type": "Question",
          "name": "Is WebP good for SEO?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes. WebP and SEO are two terms that always go hand in hand. Their design purpose is to reduce website storage space, making it run faster and smoother. And it improves search engine ranking and enhances the experience for visitors."
          }
      },{
          "@type": "Question",
          "name": "Can a WebP be a virus?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "The truth is yes. Although WebP files contain only compressed images, there are times when there is a risk associated with viruses. So it's better to scan the download for malware and check it for safety before saving."
          }
      },{
          "@type": "Question",
          "name": "What does WebP stand for?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "WebP is short for Web Picture, a file type developed by Google as a derivative and video format."
          }
      }]
    };
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        form: this.$vform({ })
    };
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onWebpToJpg() {

        this.progress = 0;

        const config = {
          onUploadProgress: (progressEvent) => this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        };

        const data = new FormData();

        data.append('local_image', this.local_image);

        this.loading = true;

        this.$axios.post(`/tool/webp-to-jpg`, data, config, { headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'multipart/form-data' } }).then(res => {
           
            jQuery('.download-image').attr( 'href',  res.data.download );

            jQuery('.preview-download-image').attr('src', res.data.preview);

            jQuery('#modalPreviewDownloadImage').modal('show');

        }).catch(e => {

          this.form.errors.set(e.response.data.errors);

        }).finally(() => {

          this.loading = false

       });
    }
  }
}
